import { useEffect, useState } from 'react';
import { canUseDOM } from '@marriott/mi-ui-library';

export const useGlobalNavVisibility = (enabled = false): boolean => {
    const [isNavVisible, setIsNavVisible] = useState(true);

    useEffect(() => {
        if(!enabled || !canUseDOM){
            return;
        }
        setIsNavVisible(window.scrollY <=0);
        let lastScrollY = window.scrollY;
        const handleScroll = () => {
            const currentY = window.scrollY;
            if(currentY <= 0){
                setIsNavVisible(true);
            } else if(currentY > lastScrollY){
                setIsNavVisible(false);
            } else if(currentY < lastScrollY){
                setIsNavVisible(true);
            }
            lastScrollY = currentY;
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [enabled]);
    return enabled && isNavVisible;
}